export const createUsersAchievementsRequests = (client) => ({
    listUsersAchievements: async (params) => {
        const { data, meta, links } = await client.api.get("users_achievements", {
            params: params,
        });
        return { data, meta, links };
    },
    findUserAchievement: async (params) => {
        const { data } = await client.api.get(`users_achievements/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map